module.exports = __webpack_public_path__ + "img/telescope_1.2537ecf0.png";